module.exports = __webpack_public_path__ + "img/img_quan.44771dea.png";